import WithHyperLink from 'library/hoc/withHyperLink';
import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Flex, Input, Row, Table, Typography } from 'zui/Antd';

const { Text } = Typography;
const { Search } = Input;

const TeamsTable = ({ teamsByPerson }) => {
	// Local state
	const [filteredData, setFilteredData] = useState([]);

	useEffect(() => {
		setFilteredData(teamsByPerson);
	}, [teamsByPerson]);

	// HOC
	const NameWithLink = WithHyperLink((a) => {
		return <Text>{a.children}</Text>;
	});

	const ButtonWithLink = WithHyperLink(() => (
		<Button size='small' className='previewButton'>
			View
		</Button>
	));

	const handleSearch = (query) => {
		const searchResult = teamsByPerson.filter((object) => object.name.toLowerCase().includes(query.toLowerCase()));
		setFilteredData(searchResult);
	};

	const columns = [
		{
			title: 'Team Name',
			dataIndex: 'name',
			key: 'name',
			ellipsis: true,
			render: (text, record) => (
				<NameWithLink type='team' dataID={record.teamID}>
					{text}
				</NameWithLink>
			)
		},
		{
			title: 'Team Description',
			dataIndex: 'description',
			key: 'description',
			ellipsis: true
		},
		{
			key: 'View',
			render: (text, record) => (
				<Flex justify='center'>
					<ButtonWithLink
						type='team'
						dataID={record.teamID}
						size='small'
						className='previewButton'
						style={{
							height: '28px',
							lineHeight: '28px',
							fontSize: '12px',
							fontWeight: '500'
						}}
						value={text.personID}
					>
						View
					</ButtonWithLink>
				</Flex>
			),
			ellipsis: true
		}
	];

	return (
		<Card
			title='Teams'
			styles={{
				header: {
					fontSize: 20,
					borderBottom: 0
				},
				body: {
					paddingTop: 0
				}
			}}
		>
			<Row gutter={16} justify='start'>
				<Col lg={24} md={24} sm={24} xs={24}>
					<Search
						style={{ marginBottom: '10px', marginTop: '4px' }}
						placeholder='Search Team Name'
						enterButton='Search'
						loading={false}
						onChange={(e) => {
							handleSearch(e.target.value);
						}}
						onSearch={(query) => {
							handleSearch(query);
						}}
					/>
				</Col>
				<Col lg={24} md={24} sm={24} xs={24}>
					<Table columns={columns} pagination={{ pageSize: 5 }} dataSource={filteredData} rowKey='teamID' />
				</Col>
			</Row>
		</Card>
	);
};

export default TeamsTable;
